import { EntityActions } from '../common/base/entity'

export class ProcessFlowAction extends EntityActions {
	constructor(options) {
		super(options)
	}
}
